import * as actions from './actions'
import { success, failure } from 'utilities/actions'
import type { Action } from '../types'
import type { Report } from 'types'

export type State = {
  data: Report[];
  errors: any[];
};

export const initialState = {
  data: [],
  errors: []
} as const

// @ts-expect-error - TS2322 - Type '{ readonly data: readonly []; readonly errors: readonly []; }' is not assignable to type 'State'.
const reducer = (state: State | null | undefined = initialState, action: Action) => {
  switch (action.type) {
    case actions.API_ORGANISATIONS_MEMBERSHIPS_INDEX:
      return initialState
    case success(actions.API_ORGANISATIONS_MEMBERSHIPS_INDEX):
      return { ...initialState, data: action.data }
    case failure(actions.API_ORGANISATIONS_MEMBERSHIPS_INDEX):
      return { ...initialState, errors: action.errors }
    default:
      return state
  }
}

export default reducer
